import React, { useState } from "react";
import {
  TableCell,
  TableRow,
  Collapse,
  Table,
  TableHead,
  TableBody,
  Checkbox,
  FormControlLabel,
  Button
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { routes, jobStatus } from "@utils/constant";
import { utcToTimezone, jobListingRequestStyle } from "@utils/commonFunctions";
import { Link } from "react-router-dom";

function Row(props) {
  const [open, setOpen] = useState(false);
  const { row, } = props;
  const handleAccordian = () => {
    setOpen(!open);
  };

  return (
    <>
      <TableRow onClick={handleAccordian} className="accordian-row">
        {props.isPermission &&
          row.jobStatuses &&
          row.jobStatuses.name === "Completed" ? (
          <TableCell className="check">
            <FormControlLabel
              className="custom-checkbox"
              control={
                <Checkbox
                  icon={
                    <img src={props.uncheckedIcon} alt="CheckBox" />
                  }
                  checkedIcon={
                    <img src={props.checkedIconOrange} alt="CheckBox" />
                  }
                  onChange={(e) => {
                    e.stopPropagation();
                    props.handleChange(row, e)
                  }}
                  onClick={(e) => e.stopPropagation()}
                  checked={
                    row["_rowChecked"] === true
                  }
                  name="check"
                />
              }
            />
          </TableCell>
        ) : (
          <TableCell></TableCell>
        )}
        <TableCell className="jobId">
          <div className="prime-job">
            <ExpandMore className={open ? "consolidated-job-arrow active" : "consolidated-job-arrow not-active"} />
            <Link
              to={`#`}
              style={{ pointerEvents: "none" }}
            >
              {row.id ? `P-${row.id}` : "-"}
            </Link>
            <span className="badge">PRIME</span>
          </div>
        </TableCell>
        <TableCell className="city">{row?.cities?.name || "-"}</TableCell>
        <TableCell
          className={`driver ${jobListingRequestStyle(
            row.jobStatuses &&
              row.jobStatuses?.name === jobStatus.NOT_ASSIGNED
              ? "Assign Driver"
              : row.jobStatuses?.name === jobStatus.REJECTED ||
                row.jobStatuses?.name === jobStatus.CHANGE_DRIVER
                ? "Re-Assign"
                : ""
          )}`}
        >
          {row.drivers?.name ? (
            row.jobStatuses?.name === jobStatus.CHANGE_DRIVER ? (
              <span
                className="re-assign-link"
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleDriverPopupOpen(
                    "ReAssign",
                    row.id,
                    row.jobStatuses?.name,
                    row.trucks?.id,
                    row.cities.id,
                    row.drivers?.id
                  )
                }}
              >
                {row.drivers?.name}
              </span>
            ) : [
              jobStatus.ASSIGNED,
              jobStatus.IN_TRANSIT,
              jobStatus.LODGEMENT,
              jobStatus.LOADING,
              jobStatus.UNLOADING,
            ].includes(row.jobStatuses?.name) ? (
              <span
                className="re-assign-link"
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleDriverPopupOpen(
                    "ReAssign",
                    row.id,
                    row.jobStatuses?.name,
                    row.trucks?.id,
                    row.cities.id,
                    row.drivers?.id,
                  )
                }}
              >
                {row.drivers?.name}
              </span>
            ) : (
              row.drivers?.name
            )
          ) : (
            <Button
              color="primary"
              className="primary-btn"
              onClick={(e) => {
                e.stopPropagation();
                props.handleDriverPopupOpen(
                  "ReAssign",
                  row.id,
                  row.jobStatuses?.name,
                  row.trucks?.id,
                  row.cities.id,
                  row.drivers?.id,
                )
              }}
            >
              Re-Assign driver
            </Button>
          )}
        </TableCell>
        <TableCell className="truck-rego break-word">
          {row.trucks ? row.trucks.rego : "-"}
        </TableCell>
        <TableCell
          className={`status ${props.dashboardRequestStatusColors(
            row.jobStatuses ? row.jobStatuses.name : ""
          )}`}
        >
          <span>
            {row.jobStatuses ? row.jobStatuses.name : "-"}
          </span>
        </TableCell>
        <TableCell className="customerName">
          {row.customers ? row.customers.name : "-"}
        </TableCell>
        <TableCell className="cto">
          {row.ctos ? row.ctos.name : "-"}
        </TableCell>
        <TableCell className="jobType">
          {row.jobTypes ? row.jobTypes.name : "-"}
        </TableCell>
        <TableCell className="cargoType">
          {row.cargoTypes ? row.cargoTypes.name : "-"}
        </TableCell>
        <TableCell className="date">
          {row.createdAt
            ? utcToTimezone(
              row.createdAt,
              row.cities?.timezone,
              "DD/MM/YYYY",
            )
            : "-"}
        </TableCell>
        <TableCell className="completion-date">
          {row?.completedAt
            ? utcToTimezone(
              row?.completedAt,
              row?.cities?.timezone,
              "DD/MM/YYYY"
            )
            : "-"}
        </TableCell>
      </TableRow>
      <TableRow className="sub-row">
        <TableCell className="MuiTableSubRoW" colSpan={12}>
          <Collapse in={open} className="consolidated-job-collapse">
            <Table aria-label="simple table" className="consolidated-job">
              <TableHead>
                <TableRow>
                  <TableCell className="sub-job-id">
                    <div className="flex-box">
                      <span className="title-cell">Job ID</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-awb-number">
                    <div className="flex-box">
                      <span className="title-cell">AWB Number</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-weight">
                    <div className="flex-box">
                      <span className="title-cell">Weight</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-pieces">
                    <div className="flex-box">
                      <span className="title-cell">Pieces</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-ref-no">
                    <div className="flex-box">
                      <span className="title-cell">Ref No.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row?.primeConsolidatedJobs?.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="sub-job-id">
                        <Link to={`${routes.jobDetail}/${item?.childJobId}`} target="_blank">
                          {item?.childJobId}
                        </Link>
                      </TableCell>
                      <TableCell className="sub-awb-number">{item?.childJob?.airWaybills[0]?.number}</TableCell>
                      <TableCell className="sub-weight">{item?.childJob?.airWaybills[0]?.weight}</TableCell>
                      <TableCell className="sub-pieces">{item?.childJob?.airWaybills[0]?.quantity}</TableCell>
                      <TableCell className="sub-ref-no">{item?.childJob?.referenceNo}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
